import { render, staticRenderFns } from "./AppReviewTags.vue?vue&type=template&id=77ab799c&scoped=true"
import script from "./AppReviewTags.vue?vue&type=script&lang=js"
export * from "./AppReviewTags.vue?vue&type=script&lang=js"
import style0 from "./AppReviewTags.vue?vue&type=style&index=0&id=77ab799c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab799c",
  null
  
)

export default component.exports